import { render, staticRenderFns } from "./ParentGoalSkillsTable.vue?vue&type=template&id=7f3bfb6e&"
import script from "./ParentGoalSkillsTable.vue?vue&type=script&lang=js&"
export * from "./ParentGoalSkillsTable.vue?vue&type=script&lang=js&"
import style0 from "./ParentGoalSkillsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports